module.exports = __webpack_public_path__ + "img/button-dislike.93252678.svg";